// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   IconButton,
//   Typography,
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   MenuItem,
//   Stack,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import AddEntityModal from "./commonAddEntities";
// import { useParams } from "react-router-dom";
// import apiEndPointsConfig from "../services/apiEndPoints";
// import axiosInstance from "../services/axiosInterceptors";
// import { jwtDecode } from "jwt-decode";

// const EntityConfigModal = ({ open, onClose, processName }) => {
//   const [entities, setEntities] = useState([
//     {
//       id: 1,
//       name: "Name",
//       type: "Person",
//       description: "Customer's full name.",
//     },
//     {
//       id: 2,
//       name: "Age",
//       type: "Number",
//       description: "Customer's age.",
//     },
//     {
//       id: 3,
//       name: "Profession",
//       type: "String",
//       description: "Customer's profession.",
//     },
//     {
//       id: 4,
//       name: "Earnings",
//       type: "Currency",
//       description: "Customer's reported earnings.",
//     },
//     {
//       id: 5,
//       name: "Follow-up Date",
//       type: "Date",
//       description: "Date for next follow-up call.",
//     },
//     {
//       id: 6,
//       name: "Demo Date",
//       type: "Date",
//       description: "Date for product demo.",
//     },
//   ]);
//   const { companyId, processType } = useParams();
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : "";
//   const [promptData, setPromptData] = useState([])
//   const [loading, setLoading] = useState(true);



//   console.log(companyId, "companyId", processType, "processType");

//   const payload = {
//     companyId,
//     processType,
//     promptType : "entitiesPrompt"
//   }

//   const fetchClientPromptData = async (data) => {
//     try {
//       const res = await axiosInstance.post(
//         apiEndPointsConfig?.clinetPromptData,
//         data,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setPromptData(res?.data?.data[0]?.entitiesPrompt?.systemPrompts
// );
//       setLoading(false);
//     } catch (error) {
//       const statusCode = error?.response?.data?.status?.code;
//       if (statusCode === 401) {
//         localStorage.clear();
//       } else {
//         console.error("Error while fetching dashboard details :", error);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchClientPromptData(payload);
//   }, []);

//   console.log(promptData , "promptData------");


//   const [addModalOpen, setAddModalOpen] = useState(false);
//   const entityTypes = ["String", "Number", "Date", "Currency", "Person", "Boolean"];

//   const handleDelete = (id) => {
//     setEntities(entities.filter((entity) => entity.id !== id));
//   };

//   return (
//     < Box>
//       <Box
//         open
//         onClose={onClose}
//         // maxWidth="md"
//         // fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             // minHeight: "500px",
//             backgroundColor: "#e6efff",
//             borderRadius: 3,
//             p: 2
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             pb: 1,
//           }}
//         >
//           <Box>
//             <Typography variant="h6" fontWeight="bold" sx={{ mb: 0.5 }}>
//               Entity Extraction Configuration
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Manage entities for{" "}
//               <span style={{ color: "#03a9f4", fontWeight: 600 }}>{processName}</span>.
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ p: 3, backgroundColor: "white", borderRadius: 3 }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2
//             }}
//           >
//             <Typography variant="h6" fontWeight="bold">
//               Defined Entities
//             </Typography>
//             <Button
//               startIcon={<AddCircleOutlineIcon />}
//               onClick={() => setAddModalOpen(true)}
//               sx={{
//                 textTransform: "none",
//                 color: "#7626dc",
//                 fontWeight: 600,
//               }}
//             >
//               Add New Entity
//             </Button>
//           </Box>

//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
//                     Entity Name
//                   </TableCell>
//                   <TableCell sx={{ fontWeight: "bold", width: "15%" }}>Type</TableCell>
//                   <TableCell sx={{ fontWeight: "bold", width: "50%" }}>
//                     Description
//                   </TableCell>
//                   <TableCell sx={{ fontWeight: "bold", width: "15%" }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {entities.map((entity) => (
//                   <TableRow key={entity.id} hover>
//                     <TableCell sx={{ fontWeight: 500 }}>{entity.name}</TableCell>
//                     <TableCell>{entity.type}</TableCell>
//                     <TableCell sx={{ color: "text.secondary" }}>
//                       {entity.description}
//                     </TableCell>
//                     <TableCell>
//                       <IconButton
//                         size="small"
//                         onClick={() => handleDelete(entity.id)}
//                         sx={{ color: "#ef5350" }}
//                       >
//                         <DeleteOutlineIcon fontSize="small" />
//                       </IconButton>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>

//         <DialogActions sx={{ p: 3, pt: 2 }}>
//           <Button
//             variant="contained"
//             onClick={onClose}
//             sx={{
//               textTransform: "none",
//               backgroundColor: "#03a9f4",
//               "&:hover": { backgroundColor: "#0288d1" },
//               px: 4,
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Box>
//       <AddEntityModal
//         open={addModalOpen}
//         onClose={() => setAddModalOpen(false)}
//         onSave={(newEntity) => setEntities([...entities, newEntity])}
//       />
//     </Box>
//   );
// };

// export default EntityConfigModal;



import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Container,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../services/axiosInterceptors';
import apiEndPointsConfig from '../services/apiEndPoints';

const EntityConfigModal = () => {

  const { companyId, processType } = useParams();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const [promptData, setPromptData] = useState({})
  const [messages, setMessages] = useState(promptData);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  console.log(location, "locationlocation");




  console.log(companyId, "companyId", processType, "processType");

  const payload = {
    companyId,
    processType,
    promptType: "entitiesPrompt"
  }

  const ProcessPayload = {
    companyId,
    process: processType
  }

  console.log(ProcessPayload);


  const fetchClientPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.clinetPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.entitiesPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  const updateClientPromptData = async (data) => {
    try {
      const updatePayload = {
        companyId,
        processType,
        entitiesPrompt: messages
      };
      const res = await axiosInstance.patch(
        apiEndPointsConfig?.updateClientPrompt,
        updatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchClientPromptData(payload)
    } catch (error) {
      console.error("Update failed", error);
    }
  };

  const fetchProcessPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.processPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.entitiesPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  useEffect(() => {
    if (location.state?.from === "/super-admin/process-management") {
      fetchProcessPromptData(ProcessPayload)
    } else {
      fetchClientPromptData(payload);
    }

  }, []);


  const [editingMessage, setEditingMessage] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [expanded, setExpanded] = useState('m1');


  const messageTitles = {
    m1: "System Role Definition",
    m2: "Transcript Understanding",
    m3: "Entity Categories",
    m4: "Extraction Logic",
    m5: "Output Format",
    m6: "JSON Format Specification",
    m7: "Output Constraints"
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleEdit = (messageKey) => {
    setEditingMessage(messageKey);
    setTempValue(messages[messageKey]);
  };

  const handleSave = (messageKey) => {
    setMessages({ ...messages, [messageKey]: tempValue });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleCancel = () => {
    setEditingMessage(null);
    setTempValue('');
  };

  const handleReset = (messageKey) => {
    setMessages({ ...messages, [messageKey]: messages[messageKey] });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleResetAll = () => {
    setMessages(messages);
    setEditingMessage(null);
    setTempValue('');
  };

  const handleSaveAll = () => {
    updateClientPromptData()
  };

  const getMessageNumber = (key) => key.replace('m', '');

  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', p: 4 }}>
      <Box >
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5, color: "#7626dc" }}>
                Prompt Configuration
              </Typography>
              <Typography variant="body2">
                Configure and customize AI prompt messages for entity extraction
              </Typography>
            </Box>
            <Stack direction="row" spacing={2}>
              <Button
                startIcon={<RestoreIcon />}
                onClick={handleResetAll}
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Reset All
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveAll}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#7626dc',
                  '&:hover': { backgroundColor: '#0288d1' },
                  px: 3,
                }}
              >
                Save All Changes
              </Button>
            </Stack>
          </Box>
        </Paper>

        {/* Messages Section */}
        <Stack spacing={2}>
          {Object.entries(messages).map(([key, value]) => (
            <Accordion
              key={key}
              expanded={expanded === key}
              onChange={handleAccordionChange(key)}
              sx={{
                backgroundColor: 'white',
                '&:before': { display: 'none' },
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                borderRadius: '8px !important',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  '&:hover': { backgroundColor: '#f8f9fa' },
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
                  <Chip
                    label={`M${getMessageNumber(key)}`}
                    size="small"
                    sx={{
                      backgroundColor: '#7626dc',
                      color: 'white',
                      fontWeight: 'bold',
                      minWidth: 45,
                    }}
                  />
                  <Typography fontWeight={600} sx={{ flexGrow: 1 }}>
                    {messageTitles[key]}
                  </Typography>
                  {messages[key] !== messages[key] && (
                    <Chip
                      label="Modified"
                      size="small"
                      color="warning"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Divider sx={{ mb: 2 }} />
                {editingMessage === key ? (
                  <Box>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      maxRows={12}
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'monospace',
                          fontSize: '0.9rem',
                        },
                      }}
                    />
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleSave(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Save
                      </Button>
                      <Button
                        startIcon={<CancelIcon />}
                        variant="outlined"
                        size="small"
                        onClick={handleCancel}
                        sx={{ textTransform: 'none' }}
                      >
                        Cancel
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                ) : (
                  <Box>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        mb: 2,
                        backgroundColor: '#f8f9fa',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 300,
                        overflow: 'auto',
                      }}
                    >
                      {value}
                    </Paper>
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<EditIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleEdit(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Edit Message
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>

        {/* Info Section */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mt: 3,
            backgroundColor: 'white',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Click on any message to expand and edit its content. Use "Save All Changes" to apply your modifications.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default EntityConfigModal;